import request from '@/utils/request'
import { getToken } from '../utils/auth'
// 查询设备出厂分配
export function querydevicepreorg (params) {
  params.token = getToken()
  return request({
    url: '/querydevicepreorg',
    method: 'post',
    params
  })
}
// 出厂设备分配
export function updatedevicepreorg (data) {
  return request({
    url: '/updatedevicepreorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}
// 搜索设备出厂设置
export function searchdevicepreorg (data) {
  return request({
    url: '/searchdevicepreorg',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/factoryReset.js